module.exports = {
  accepts: ["EARLY_BIRD"],
  rejects: ["TIME"],
  token: {
    superscript: "^^",
  },
};
